var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 51.3335H16.3334C7.00002 51.3335 4.66669 49.0002 4.66669 39.6668V35.0002C4.66669 25.6668 7.00002 23.3335 16.3334 23.3335H39.6667C49 23.3335 51.3334 25.6668 51.3334 35.0002V39.6668C51.3334 49.0002 49 51.3335 39.6667 51.3335Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.3332V18.6665C14 10.9432 16.3333 4.6665 28 4.6665C38.5 4.6665 42 9.33317 42 16.3332",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 43.1667C31.2217 43.1667 33.8334 40.555 33.8334 37.3333C33.8334 34.1117 31.2217 31.5 28 31.5C24.7784 31.5 22.1667 34.1117 22.1667 37.3333C22.1667 40.555 24.7784 43.1667 28 43.1667Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.dad91670dd65dd4230707c4a9daf2cee.svg";
export { ForwardRef as ReactComponent };